import React from 'react';
import { useSelector } from 'react-redux';

const GlobeItem = () => {
  const marketLanguageItems = useSelector(
    (state) => state.navigation.marketLanguageItems
  );

  const handleLanguageChange = (e) => {
    const { value } = e.target;
    window.location = value;
  };

  return (
    <>
      {marketLanguageItems && marketLanguageItems.length > 1 && (
      <div className="language-selector">
          <select
          className="language-selector__select"
          onChange={handleLanguageChange}
          defaultValue={marketLanguageItems.filter(s => s.isSelected)[0].url}
          >
          {marketLanguageItems.map((i, k) => (
              <option
              className="language-selector__option"
              key={k}
              value={i.url}
              >
              {i.name}
              </option>
          ))}
          </select>
          <i className="language-selector globe-icon"></i>
      </div>
      )}
    </>
  );
};

export default GlobeItem;

